export enum AdminBoxListAction {
  Create,
}
